// removed by extract-text-webpack-plugin
module.exports = {"preloader":"preloader__preloader-2JIoP","point":"preloader__point--G5Zj","loading":"preloader__loading-KwLcH","small":"preloader__small-2cwTf","medium":"preloader__medium-1XeBW","big":"preloader__big-34i3m"};


//////////////////
// WEBPACK FOOTER
// ./components/layout/preloader/preloader.css
// module id = 843
// module chunks = 0